<mat-chip-listbox>
  <mat-chip-option *ngFor="let option of displayedOptions"
    [ngClass]="{ selected: selectedOptions.has(option) }"
    (click)="selectOption(option)"
    matTooltipClass="tooltip-preformatted" class="gray-chip">
    {{ option }}
  </mat-chip-option>
  <a *ngIf="options.length > chipsToShow" (click)="showAllOptions = !showAllOptions">
    {{ hiddenOptions === 0 ? ('common.labels.showLess' | translate) : ('common.labels.plusMore' | translate | interpolate:hiddenOptions) }} 
  </a>
</mat-chip-listbox>
